import React, { useCallback, useEffect, useState } from 'react';
import { getProjectBoundary, getProjectFellingAreas, getEmployeeTaskMap } from '../../services/api';
import { ProjectMapCard } from './ProjectMapCard';

export const ProjectMapSection = ({ project, isAdmin, onProjectChange }) => {
  const [boundary, setBoundary] = useState(null);
  const [areas, setAreas] = useState([]);

  const reloadAreas = useCallback(async () => {
    try {
      setAreas(await getProjectFellingAreas(project.id));
    } catch (error) {
      setAreas([]);
    }
  }, [project.id]);

  useEffect(() => {
    if (!project?.boundary_meta) {
      setBoundary(null);
      return;
    }
    getProjectBoundary(project.id).then((data) => setBoundary(data.geojson)).catch(() => setBoundary(null));
  }, [project?.id, project?.boundary_meta]);

  useEffect(() => { reloadAreas(); }, [reloadAreas]);

  const handleBoundaryChanged = (changes) => {
    setBoundary(changes.geojson || null);
    const { geojson, ...projectChanges } = changes;
    onProjectChange?.(projectChanges);
  };

  return (
    <ProjectMapCard
      project={project}
      boundary={boundary}
      boundaryMeta={project.boundary_meta}
      areas={areas}
      canEdit={isAdmin}
      showLayers={isAdmin}
      onBoundaryChanged={handleBoundaryChanged}
      reloadAreas={reloadAreas}
    />
  );
};

export const EmployeeTaskMap = ({ taskId }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    getEmployeeTaskMap(taskId).then(setData).catch(() => setData(null));
  }, [taskId]);

  if (!data?.project) return null;
  return (
    <ProjectMapCard
      project={data.project}
      boundary={data.boundary}
      boundaryMeta={data.boundary ? { filename: 'Īpašuma robežas', area_ha: null } : null}
      areas={data.felling_areas || []}
      canEdit={false}
      showLayers
      compact
    />
  );
};

export default ProjectMapSection;
